<div>
  <div class="parcel-title">
    <span class="title-primary">Parcel Info</span>
    <fa-icon
      *ngIf="!readOnly"
      (click)="removeParcel($event)"
      [icon]="['far', 'trash']"
      class="red remove-parcel"></fa-icon>
  </div>
  <div
    class="parcel-details">
    <div class="parcel-svg-container"
         matTooltip="Click to zoom to parcel"
         matTooltipClass="fc-tooltip-map"
         (click)="centerOnParcel()" #dataContainer></div>
    <div class="parcel-info-table">
      <table aria-describedby="Parcel Info Table" role="presentation">
        <tr class="parcel-row">
          <td class="row-header">Address</td>
          <td class="row-value">
            @if (parcel.id === null) {
              <span class="address-line-1">
                {{ buildAddressLine1(parcel) }}
              </span>
              <ng-container *ngIf="parcel.feature.properties.address2">
                <span class="address-line-1">
                  {{ parcel.feature.properties.address2 }}
                </span>
              </ng-container>
              <span class="city-state">
                {{ buildAddressCityState(parcel) }}
              </span>
            } @else {
              <span class="address-line-1">
                {{ parcel.address }}
              </span>
            }
          </td>
        </tr>
        <tr class="parcel-row">
          <td class="row-header">Owner</td>
          <td class="row-value">
            {{ parcel.id === null ? parcel.feature.properties.owner : parcel.owner }}
          </td>
        </tr>
        <tr class="parcel-row">
          <td class="row-header">Approx. Size</td>
          <td class="row-value">{{ approxSize }} Total Acres</td>
        </tr>
        <tr class="parcel-row">
          <td class="row-header">Parcel Number</td>
          <td class="row-value">{{ parcel.parcelNumber }}</td>
        </tr>
        @if (isAdmin) {
          <tr class="parcel-row">
            <td class="row-header">Last Refreshed</td>
            <td class="row-value">{{ parcel.llUpdatedAt | date: 'longDate' }}</td>
          </tr>
          <tr class="parcel-row">
            <td class="row-header">ll_uuid</td>
            <td class="row-value"><a href="https://app.regrid.com/search?query={{parcel.llUuid}}"
                                     rel="noopener noreferrer" target="_blank">{{ parcel.llUuid }}</a></td>
          </tr>
        }
        <tr>
          <td colspan="2">
            <div *ngIf="!parcel.inRegion" class="parcel-not-available">
              This parcel is not available. Please remove.
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</div>
